<template>
  <div class="self_adaption">
    <div class="self_adaption_main">
      <el-form ref="form" :model="form" label-width="96px" label-position="right" class="FormFlex"
        style="justify-content: space-between;">
        <div class="FormBtn" style="width:100%;display:flex;justify-content:flex-end;">
          <el-button type="success" size="medium" @click="addSpeak()">添加发言内容</el-button>
        </div>
      </el-form>
      <div v-for="(item, index) in Data" :key="index">
        <el-table class="table_header" :data="[item[0]]" border style="width: 100%" :show-header="status">
          <el-table-column align="center" label="日期" width="60">
            <template>
              {{ $nzhcn.encodeS(index + 1) }}
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template v-slot="scoped">
              {{ scoped.row.type === 1 ? '发言人 ' + scoped.row.speaker : '主持人 ' + scoped.row.speaker }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="操作" width="220">
            <template  v-slot="scoped">
              <el-tag style="margin:0px 5px" @click="editData('all', scoped.row)" size="small"
                class="cursor">整体编辑</el-tag>
              <el-tag style="margin:0px 5px" @click="delData('all', scoped.row)" size="small"
                class="cursor">整体删除</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="item" border style="width: 100%" :show-header="status">
          <el-table-column align="center" type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="content" align="center" label="内容">
            <template v-slot="scoped">
              <div class="div-table-content" v-html="scoped.row.content"></div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="220">
            <template  v-slot="scoped">
              <el-tag style="margin:0px 5px" @click="editData('one', scoped.row)" size="small"
                class="cursor">编辑</el-tag>
              <el-tag style="margin:0px 5px" @click="delData('one', scoped.row)" size="small" class="cursor">删除</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="新增发言内容" :visible.sync="dialogVisible" width="50%">
      <el-form ref="submitForm" :model="submitForm" label-width="96px" label-position="right" class="FormFlex" style="justify-content: space-between;">
        <el-form-item label="发言人：">
          <el-select v-model="submitForm.attendeeId" filterable placeholder="请选择发言人" @change="selectChange">
            <el-option v-for="(item, index) in options" :key="index" :label="item.duty + item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="FormBtn" style="display:flex;justify-content:flex-end;">
          <el-button size="mini" type="success" icon="el-icon-plus" @click="add()"></el-button>
          <el-button size="mini" type="danger" icon="el-icon-minus" @click="del()"></el-button>
        </div>
      </el-form>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border>
        <el-table-column align="center" label="序号" width="60" type="index"></el-table-column>
        <el-table-column align="center" label="发言内容">
          <template  v-slot="scoped">
            <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 30}" v-model="scoped.row.content" placeholder="请输入发言内容" border="none"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="submitDiv">
        <el-button type="success" @click="submit()">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑单个 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="编辑发言内容"
      :visible.sync="dialogVisibleOne" width="50%">
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border>
        <el-table-column align="center" label="序号" width="60" type="index"></el-table-column>
        <el-table-column align="center" label="发言内容">
          <template  v-slot="scoped">
            <el-input type="textarea"  :autosize="{ minRows: 8, maxRows: 30}" v-model="scoped.row.content" placeholder="请输入发言内容" border="none"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="submitDiv">
        <el-button type="success" @click="submitEditOne()">确认</el-button>
        <el-button @click="dialogVisibleOne = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑多个 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="编辑发言内容" :visible.sync="dialogVisibleAll" width="50%">
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border>
        <el-table-column align="center" label="序号" width="60" type="index"></el-table-column>
        <el-table-column align="center" label="发言内容">
          <template  v-slot="scoped">
            <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 30}" v-model="scoped.row.content" placeholder="请输入发言内容" border="none"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="FormBtn" style="display:flex;justify-content:flex-end;">
        <el-button size="mini" type="success" icon="el-icon-plus" @click="add()"></el-button>
        <el-button size="mini" type="danger" icon="el-icon-minus" @click="del()"></el-button>
      </div>
      <div class="submitDiv">
        <el-button type="success" @click="submitEdit()">确认</el-button>
        <el-button @click="dialogVisibleAll = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  surveySpeechList,
  surveyAttendList,
  surveySpeechSave,
  surveySpeechDel,
  surveySpeechDelById,
  surveySpeechEdit,
  surveySpeechEditById,
  surveySpeechSaveSingle
} from '@/api/axiosUrl';
import {lineBrake2Dom} from "../../utils/tools";

export default {
  name: 'Progress',
  components: {},
  props: { dataId: String },
  data () {
    return {
      status: false,
      dialogVisible: false,
      dialogVisibleOne: false,
      dialogVisibleAll: false,
      form: {},
      select: {},
      options: [],
      submitForm: {},
      tableData: [{
        content: '',
        orderNo: '1'
      }],
      editOne: {},
      editAll: [],

      Data: []
    };
  },
  created () {
    surveyAttendList({ surveyId: this.dataId }).then(res => {
      if (res.data.length) {
        this.options = res.data
      }
    });
    this.renderData();
  },
  methods: {
    addSpeak () {
      this.dialogVisible = true;
      this.tableData = [{
        content: '',
        orderNo: '1'
      }]
      this.$set(this, 'submitForm', {})
    },
    //进入页面去渲染数据
    renderData () {
      this.Data = []
      surveySpeechList({ surveyId: this.dataId }).then(res => {
        if (!res.data.length) {
          return;
        }
        let arrFlag = res.data[0].groupId;
        let arr = [];
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].content = lineBrake2Dom(res.data[i].content, "p")
          if (arrFlag === res.data[i].groupId) {
            arr.push(res.data[i])
            continue
          }
          this.Data.push(arr)
          arr = [res.data[i]]
          arrFlag = res.data[i].groupId
        }
        this.Data.push(arr)
      });

    },
    selectChange (val) {
      for (let i = 0; i < this.options.length; i++) {
        if (val == this.options[i].id) {
          this.selectForm = this.options[i]
          break
        }
      }
    },
    add () {
      let attendeeId = this.tableData[0].attendeeId
      let speaker = this.tableData[0].speaker
      let speechType = 0
      let surveyId = this.tableData[0].surveyId
      let orderNo = this.tableData.length+1
      this.tableData.push({ content: '',attendeeId: attendeeId,speaker: speaker,speechType: speechType,surveyId: surveyId,orderNo: orderNo })
    },
    del () {
      if (this.tableData.length == 1) {
        this.Messager('至少保留一个', 'warning')
      } else {
        this.tableData.splice(-1, 1)
      }
    },
    submit () {
      let _this = this
      console.log(this.tableData)
      var params = JSON.parse(JSON.stringify(this.tableData))
      for (let i = 0; i < params.length; i++) {
        params[i].attendeeId = this.selectForm.id
        params[i].speaker =this.selectForm.duty + ' ' + this.selectForm.name
        params[i].speechType = 0
        params[i].surveyId = this.selectForm.surveyId
      }
      surveySpeechSave({ speeches: params }).then(res => {
        if (res.status == 200) {
          this.Messager('保存成功', 'success')
          setTimeout(function () {
            _this.dialogVisible = false
            _this.renderData()
          }, 500)
        }
      })
    },
    editData (flag, data) {
      let _this = this
      _this.tableData = []

      if (flag == 'all') {
        _this.dialogVisibleAll = true
        surveySpeechEdit({ surveyId: data.surveyId, groupId: data.groupId }).then(res => {
          if (res.status == 200) {
            for (let i = 0; i < res.data.length; i++) {
              _this.tableData.push(res.data[i])
            }
          }
        })
      } else {
        _this.dialogVisibleOne = true
        surveySpeechEditById({ id: data.id }).then(res => {
          if (res.status == 200) {
            _this.tableData.push(res.data)
          }
        })
      }
    },
    // 保存编辑多个
    submitEdit () {
      let _this = this
      var params = {
        speeches: [],
        groupId:this.tableData[0].groupId
      }

      for (let i = 0; i < this.tableData.length; i++) {
        params.speeches.push(this.tableData[i])
      }
      surveySpeechSave(params).then(res => {
        if (res.status == 200) {
          this.Messager('修改成功', 'success')
          setTimeout(function () {
            _this.dialogVisibleAll = false
            _this.renderData()
          }, 500)
        }
      })
    },
    // 保存编辑单个
    submitEditOne () {
      let _this = this
      var params = this.tableData[0]

      surveySpeechSaveSingle(params).then(res => {
        if (res.status == 200) {
          this.Messager('修改成功', 'success')
          setTimeout(function () {
            _this.dialogVisibleOne = false
            _this.renderData()
          }, 500)
        }
      })
    },
    //整体删除和删除单个
    delData (flag, data) {
      let _this = this
      _this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {}
        if (flag == 'all') {
          surveySpeechDel({ surveyId: data.surveyId, groupId: data.groupId }).then(res => {
            if (res.status == 200) {
              _this.Messager('删除成功', 'success')
              _this.renderData()
            } else {
              _this.Messager('删除失败', 'error')
            }
          })
        } else {
          params.id = data.id
          surveySpeechDelById({ id: data.id }).then(res => {
            if (res.status == 200) {
              _this.Messager('删除成功', 'success')
              _this.renderData()
            } else {
              _this.Messager('删除失败', 'error')
            }
          })
        }
      })
    },
    //警告提示
    Messager (text, messageType) {
      this.$message({ message: text, type: messageType })
    }
  }
};
</script>

<style scoped>
::v-deep .table_header tr {
  background: #F2F2F2 !important;
}

::v-deep .table_header tr:hover {
  background: #F2F2F2 !important;
}
.div-table-content {
  text-align: left;
  /*text-indent: 2em;*/
   white-space:pre-wrap;;
}
</style>
